import { DashboardContainerHeader } from 'app/layout/dashboardLayout/BoxLayout';
import DividendsAttachments from './Dividends/attatchments';
import InterestAttachments from './Interest/attatchments';
import PensionAttachments from './Pension/attatchments';
import RentalIncomeAttachments from './RentalIncome/attatchments';

export interface IPassiveIncomeAttachmentsProps {}

export default function PassiveIncomeAttachments(
  props: IPassiveIncomeAttachmentsProps,
) {
  return (
    <div>
      <DashboardContainerHeader title="Income / Passive Income" />
      <DividendsAttachments />
      <InterestAttachments />
      <PensionAttachments />
      <RentalIncomeAttachments />
    </div>
  );
}
